import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Inject,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { select, Store } from "@ngrx/store";
import { MultiSessionLimitAction, MultiSessionLimitSelector } from "@obg/ngx.common";
import { merge, Subscription } from "rxjs";
import { filter, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-session-limit-expired-alert-v2",
	templateUrl: "./session-limit-expired-alert-v2.container.html",
	styleUrls: ["./session-limit-expired-alert-v2.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SessionLimitExpiredAlertContainerV2 implements OnInit, OnDestroy {
	dailySessionLimitHours: number | undefined;
	private data$$: Subscription | undefined;

	constructor(
		@Inject(MAT_DIALOG_DATA) public nextTimeLogin: string | undefined,
		private multiSessionLimitAction: MultiSessionLimitAction,
		private multiSessionLimitSelector: MultiSessionLimitSelector,
		private changeDetector: ChangeDetectorRef,
		private store: Store
	) {}

	ngOnInit() {
		const limits$ = this.store.pipe(
			select(this.multiSessionLimitSelector.get()),
			filter((sessionLimit) => sessionLimit?.current?.dailySessionLimit !== undefined),
			tap((sessionLimit) => {
				this.dailySessionLimitHours = sessionLimit?.current?.dailySessionLimit;
				this.store.dispatch(this.multiSessionLimitAction.clear());
			})
		);

		this.data$$ = merge(limits$).subscribe(() => this.changeDetector.markForCheck());
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}
}
